import { render, staticRenderFns } from "./RawMessageView.vue?vue&type=template&id=77803a15&scoped=true&"
import script from "./RawMessageView.vue?vue&type=script&lang=ts&"
export * from "./RawMessageView.vue?vue&type=script&lang=ts&"
import style0 from "./RawMessageView.vue?vue&type=style&index=0&id=77803a15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77803a15",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/rensvannijnatten/source/repos/AZNConnect/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VTooltip})
